import type { ResourceFilterOption } from '@/shared/ui/Layout'

import { resolveItemPartner } from './resolveItemPartner'
import type { StoreCatalogItem } from './types'

type PartnerLookup = Record<string, string>

export const deriveStorePartnerOptions = (
  items: StoreCatalogItem[],
  partnerNameById: PartnerLookup = {}
): ResourceFilterOption<string>[] => {
  const byId = new Map<string, string>()

  items.forEach(item => {
    const partner = resolveItemPartner(item, partnerNameById)
    if (!partner) return

    byId.set(partner.id, partner.label)
  })

  return Array.from(byId.entries())
    .map(([id, label]) => ({ id, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
}
